<div class="wrapper-list-stores">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <a
            routerLink="/dashboard/overview"
            class="btn btn-back" [attr.aria-label]="'Back' | translate">
            <i class="fi-rr-arrow-alt-left"></i>
          </a>
          <div class="title" [attr.data-parent]="'Dashboard' | translate">{{ "Product FAQs" | translate }}</div>
        </div>
      </div>
      <div class="col text-right">
        <div class="d-inline-block">
          <button
            class="btn btn-primary"
            routerLink="/dashboard/product-faq/create"
          >
            {{ "Create Product FAQs" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="fixed bottom w-[86.8%] md:w-[80%] z-50 bottom-0 pointer-events-none"
  >
    <div
      class="md:w-1/2 sm:w-[80%] w-full mt-10 bg-indigo-500 text-white p-2 shadow-md mx-auto transition ease-in-out duration-400 rounded flex place-content-between pointer-events-auto"
      [class]="
        isArrangementModified
          ? '-translate-y-1/2 opacity-100'
          : 'translate-y-full opacity-0'
      "
    >
      <span class="align-self-center ml-2">{{
        isArrangementModified
          ? ("Product FAQ arrangement has been modified! Save now?" | translate)
          : ("Not Modified" | translate)
      }}</span>
      <button
        class="bg-white text-indigo-600 px-4 py-2 rounded hover:!bg-indigo-100 transition duration-300 ease-in-out"
        [class]="
          isSavingArrangement
            ? 'pointer-events-none !bg-white/[.6]'
            : 'pointer-events-auto'
        "
        (click)="saveProductFaqArrangement($event)"
      >
        {{ "Save" | translate }}
      </button>
    </div>
  </div>

  <div class="checkout-toolbar mb-4">
    <div class="filter-options">
      <!-- Country Filter Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="filteredCountry && filteredCountry !== 'ALL'"
          id="dropdownCountry"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-globe mr-1"></i>
          <span>{{ getCountryName(filteredCountry) | translate }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownCountry" class="custom-dropdown shadow-md" style="min-width: 220px; max-height: 320px; overflow-y: auto;">
          <button
            ngbDropdownItem
            *ngFor="let c of country"
            (click)="changeCountry(c.country_code)"
            class="py-2"
          >
            <div class="d-flex align-items-center">
              <img
                *ngIf="c.country_code && c.country_code !== 'ALL'"
                [src]="getFlagImageURL(c.country_code)"
                class="mr-2 flex-shrink-0"
                style="width: 20px; height: 14px; object-fit: cover; border-radius: 2px;"
              />
              <i *ngIf="!c.country_code || c.country_code === 'ALL'" class="fi fi-rr-globe mr-2 text-muted" style="font-size: 14px;"></i>
              <span class="text-truncate">{{ c.country_name | translate }}</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Language Filter Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="language_code"
          id="dropdownLanguage"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-world mr-1"></i>
          <span>{{ language_name | translate }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownLanguage" class="custom-dropdown shadow-md" style="min-width: 180px;">
          <button
            ngbDropdownItem
            *ngFor="let l of language"
            (click)="changeLanguage(l.language_code, l.language_name)"
            class="py-2"
          >
            <span>{{ l.language_name | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Search Input Box -->
    <div class="search-box">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="filteredString"
        (input)="updateFilter($event)"
        placeholder="{{ 'Search by FAQs title / Product Name' | translate }}..."
      />
      <i class="fi fi-rr-search search-icon"></i>
      <i class="fas fa-times clear-icon" *ngIf="filteredString" (click)="clearProductFaqSearch()"></i>
    </div>
  </div>

  <div class="section-main">
    <!-- Product Listing View: Tiles -->
    <div class="product-list">
      <div *ngIf="loading; else loadedContent">
        <div class="loading-spinner col-12 mt-5">
          <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
        </div>
      </div>
      <ng-template #loadedContent>
        <div *ngIf="!loading" cdkDropListGroup>
          <div class="flex flex-wrap ease-in-out duration-300 py-3">
            <div
              *ngFor="let item of getDisplayedProductsFaqs(); let i = index"
              cdkDropList
              [cdkDropListEnterPredicate]="dropListEnterPredicate"
              class="select-none product-item-tile duration-1000 transition ease-in-out w-full group -mb-3"
            >
              <div
                cdkDrag
                (cdkDragMoved)="dragMoved($event)"
                (cdkDragDropped)="dragDropped($event)"
                [cdkDragData]="item"
                class="drag-box"
              >
                <div
                  class="flex relative transition bg-white duration-300 ease-in-out shadow-sm hover:!shadow-lg group flex-column border !border-transparent rounded hover:!border-indigo-200"
                >
                  <div class="flex justify-between w-full px-3 py-3 !pt-2">
                    <div class="col-md-6 flex p-0">
                      <div
                        class="text-start truncate align-items-center flex mr-2"
                      >
                        <div
                          class="text-sm font-medium text-start flex items-center w-6 h-6 justify-center cursor-grab"
                        >
                          <svg
                            width="16"
                            height="6"
                            viewBox="0 0 16 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15 0H1C0.45 0 0 0.45 0 1C0 1.55 0.45 2 1 2H15C15.55 2 16 1.55 16 1C16 0.45 15.55 0 15 0ZM1 6H15C15.55 6 16 5.55 16 5C16 4.45 15.55 4 15 4H1C0.45 4 0 4.45 0 5C0 5.55 0.45 6 1 6Z"
                              fill="#747E8B"
                            />
                          </svg>
                        </div>
                      </div>
                      <div class="col-md-6 text-start truncate">
                        <div
                          class="capitalize text-sm font-medium text-start truncate"
                        >
                          {{ item.title?.toLowerCase() }}
                        </div>
                        <div class="text-xs">
                          {{ item.language_name }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2 text-center">
                      <div>
                        <p
                          class=""
                          #tooltip="matTooltip"
                          matTooltip="Created on {{
                            item.created_at.date | date : 'medium'
                          }}"
                          matTooltipPosition="above"
                          matTooltipHideDelay="100"
                          class="text-sm {{
                            item.content_updated_at == null ||
                            (item.content_updated_at !== null &&
                              item.content_updated_at.date ===
                                item.created_at.date)
                              ? 'center-middle'
                              : ''
                          }}"
                        >
                          {{ item.created_at.date | timeago : true }}
                        </p>
                        <p
                          *ngIf="
                            item.content_updated_at !== null &&
                            item.content_updated_at.date !==
                              item.created_at.date
                          "
                          #tooltip="matTooltip"
                          matTooltip="Edited on {{
                            item.content_updated_at.date | date : 'medium'
                          }}"
                          matTooltipPosition="above"
                          matTooltipHideDelay="100"
                          class="text-slate-400 text-xs mt-1"
                        >
                          {{ "Edited" | translate }}
                          {{ item.content_updated_at.date | timeago : true }}
                        </p>
                      </div>
                    </div>
                    <div class="actions self-center flex gap-1">
                      <div class="action-group whitespace-nowrap">
                        <button
                          type="button"
                          class="rounded-md ml-2 text-xs bg-white justify-center items-center h-10 transition duration-300 ease drop-shadow-xs hover:drop-shadow border-gray-200 group-hover:border-indigo-300 hover:!border-indigo-200 !border text-indigo-600 hover:!bg-indigo-50/[0.5] group hover:no-underline px-2 w-8"
                          (click)="edit(item.id)"
                        >
                          <i class="fi fi-rr-edit"></i>
                        </button>
                        <button
                          type="button"
                          class="rounded-md ml-2 text-xs bg-white justify-center items-center h-10 transition duration-300 ease drop-shadow-xs hover:drop-shadow border-red-200 group-hover:border-red-300 hover:!border-red-200 !border text-red-600 hover:!bg-red-50/[0.5] group hover:no-underline px-2 w-8"
                          (click)="open(content, item.id)"
                        >
                          <i class="fi fi-rr-trash"></i>
                        </button>
                        <button
                          type="button"
                          class="rounded-md ml-2 text-xs bg-white justify-center items-center h-10 transition duration-300 ease drop-shadow-xs hover:drop-shadow border-slate-300 group-hover:border-slate-300 hover:!border-slate-400 !border text-slate-600 hover:!bg-slate-200/[0.5] group hover:no-underline px-2 w-8"
                          (click)="open(duplicate, item.id)"
                        >
                          <i class="fi fi-rr-copy-alt"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="mt-5 col-12 text-center"
              *ngIf="!getDisplayedProductsFaqs()?.length"
            >
              <span>{{ "No Product FAQ found." | translate }}</span>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <div
      class="row px-4 py-3 pagination"
      *ngIf="displayedProductsFaqs?.length != 0"
    >
      <div class="col-lg-3 flex">
        <ngb-pagination
          [collectionSize]="displayedProductsFaqs.length"
          [(page)]="page"
          [pageSize]="itemPerPage"
          aria-label="Default pagination"
          (pageChange)="changePage($event)"
          [maxSize]="5"
        ></ngb-pagination>
      </div>
      <div class="col-lg-3 lg-center paginationWrapper">
        <div class="mt-2 text-center">
          {{ "Showing" | translate }} <b>{{ start + 1 }}–{{ end }}</b> {{ "of" | translate }}
          <b>{{ displayedProductsFaqs.length }}</b>
        </div>
      </div>
      <div class="col-lg-4"></div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-duplicate-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ ("Confirm to delete FAQ ?" | translate) + pageName }}
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-duplicate-body">
    <div class="text-subtitle mb-2">
      {{ "Delete " | translate }} <b>'{{ pageName }}'</b
      >{{ "? This can't be undone." | translate }}
    </div>
  </div>
  <div class="modal-duplicate-footer">
    <button
      type="button"
      class="btn-outline-cancel mr-2"
      (click)="modal.close('Save click')"
    >
      {{ "Cancel" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-danger"
      (click)="modal.close('delete')"
    >
      {{ "Delete" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #duplicate let-modal>
  <div class="modal-duplicate-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ "Duplicate this FAQ ?" | translate }}
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-duplicate-footer">
    <button
      type="button"
      class="btn-outline-cancel mr-2"
      (click)="modal.close('cancel')"
    >
      {{ "Cancel" | translate }}
    </button>
    <button
      type="button"
      class="btn-outline-duplicate"
      (click)="modal.close('submit')"
    >
      {{ "Duplicate" | translate }}
    </button>
  </div>
</ng-template>
